import React from "react";

/**
 * Duszek – custom SVG ghost mascot placeholder.
 * The user will replace this with the final illustration later.
 */
export const Ghost = ({ size = 320, className = "", eyeDirection = 0 }) => {
  const ex = 6 * Math.sin(eyeDirection);
  const ey = 3 * Math.cos(eyeDirection);
  return (
    <svg
      viewBox="0 0 320 380"
      width={size}
      height={size * (380 / 320)}
      className={className}
      role="img"
      aria-label="Duszek – bajkowy bohater"
    >
      <defs>
        <radialGradient id="body" cx="35%" cy="30%" r="80%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="55%" stopColor="#e0f2fe" />
          <stop offset="100%" stopColor="#84c5f4" />
        </radialGradient>
        <radialGradient id="cheek" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fecaca" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#fecaca" stopOpacity="0" />
        </radialGradient>
        <filter id="soft" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="4" />
        </filter>
      </defs>

      {/* Shadow */}
      <ellipse cx="160" cy="355" rx="80" ry="10" fill="#0b2a55" opacity="0.12" filter="url(#soft)" />

      {/* Body */}
      <path
        d="M60 170
           C60 90, 120 40, 160 40
           C200 40, 260 90, 260 170
           L260 300
           C260 315, 246 320, 236 310
           L216 292
           C210 286, 202 286, 196 292
           L180 308
           C174 314, 166 314, 160 308
           L144 292
           C138 286, 130 286, 124 292
           L104 310
           C94 320, 60 315, 60 300
           Z"
        fill="url(#body)"
        stroke="#0b2a55"
        strokeOpacity="0.08"
        strokeWidth="1.5"
      />

      {/* Cheeks */}
      <ellipse cx="110" cy="200" rx="22" ry="14" fill="url(#cheek)" />
      <ellipse cx="210" cy="200" rx="22" ry="14" fill="url(#cheek)" />

      {/* Eyes */}
      <g fill="#051937">
        <ellipse cx={130 + ex} cy={175 + ey} rx="9" ry="12" />
        <ellipse cx={190 + ex} cy={175 + ey} rx="9" ry="12" />
      </g>
      <g fill="#ffffff">
        <circle cx={133 + ex} cy={170 + ey} r="3" />
        <circle cx={193 + ex} cy={170 + ey} r="3" />
      </g>

      {/* Smile */}
      <path
        d="M148 215 Q160 228 172 215"
        stroke="#051937"
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />

      {/* Little sparkle */}
      <g opacity="0.85">
        <path d="M245 95 l4 -10 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 z" fill="#fde68a" />
      </g>
    </svg>
  );
};

export default Ghost;
